import { remove } from '@core/api/baseApi';

export const deleteStudyComment = (studyCommentId: string): Promise<{success: boolean}> => 
    remove(`/studies/${studyCommentId}/comments`);
